

window.onload = pageLoaded;
window.onscroll = scrollFunction;
window.addEventListener('hashchange', checkHash);

class MaterialIcon extends HTMLElement {
    connectedCallback() {
        const name = this.getAttribute("icon"); // z.B. "call", "mail"
        this.innerHTML = `
            <svg class="wx-icon" aria-hidden="true">
                <use href="#wx-icons-${name}"></use>
            </svg>
        `;
    }
}

customElements.define("custom-icon", MaterialIcon);


function pageLoaded() {
    scrollFunction();
    navHover();
    initMobileNav();
    initNavDropdowns();
    initPriceListNav();
    splideSliders();
    feedbackLoop();
    checkHash();


    if (localStorage.getItem('google_maps_consent') === 'true') {
        loadMaps();
    }
}

function scrollFunction() {
    navFixed();
}

function navFixed() {
    const navbar = document.querySelector('.nav-bar');
    if (!navbar) return;

    if (window.pageYOffset >= 16) {
        navbar.classList.add('fixed');
    } else {
        navbar.classList.remove('fixed');
    }
}

function navHover() {
    const navMain = document.querySelector(".nav-bar");
    const level1Items = document.querySelectorAll(".main-menu > .level-1.has-dropdown");

    if (!navMain || level1Items.length === 0) return;

    level1Items.forEach((item) => {
        item.addEventListener("mouseenter", () => {
            navMain.classList.add("hover-active");
            item.classList.add("current-hover");
        });

        item.addEventListener("mouseleave", () => {
            // etwas verzögert, um Zwischenräume zu ermöglichen
            setTimeout(() => {
                if (!item.matches(":hover")) {
                    navMain.classList.remove("hover-active");
                    item.classList.remove("current-hover");
                }
            }, 50);
        });
    });
}

function checkHash() {
    if (!window.location.hash) return;

    const hash = window.location.hash.substring(1); // ohne #
    const target = document.querySelector('.' + CSS.escape(hash));
    if (!target) return;

    const nav = document.querySelector('.nav-bar');
    const navHeight = nav ? nav.offsetHeight : 0;

    const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        navHeight;

    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
    });
}





function toggleAccordion(headEl) {
    const itemEl = headEl.closest(".accordion-item");
    if (!itemEl) return;

    const listEl = itemEl.closest(".accordion-list");
    if (!listEl) return;

    const contentEl = itemEl.querySelector(".accordion-content");
    if (!contentEl) return;

    const isOpen = itemEl.classList.contains("active");

    // Immer nur eins offen
    listEl.querySelectorAll(".accordion-item.active").forEach((openItem) => {
        if (openItem === itemEl) return;
        openItem.classList.remove("active");
        const openContent = openItem.querySelector(".accordion-content");
        if (openContent) collapseSmooth(openContent);
    });

    if (isOpen) {
        itemEl.classList.remove("active");
        collapseSmooth(contentEl);
    } else {
        itemEl.classList.add("active");
        expandSmooth(contentEl);
    }
}

function expandSmooth(el) {
    // Startzustand
    el.style.transition = "none";
    el.style.overflow = "hidden";
    el.style.height = "0px";

    // Reflow
    el.offsetHeight;

    // Zielhöhe setzen
    requestAnimationFrame(() => {
        el.style.transition = "height 300ms ease";
        el.style.height = el.scrollHeight + "px";
    });

    // Nachmessen, wenn Bilder (lazy) nachladen und scrollHeight sich ändert
    const imgs = el.querySelectorAll("img");
    imgs.forEach((img) => {
        if (img.complete) return;
        img.addEventListener(
            "load",
            () => {
                // nur wenn noch offen
                if (el.closest(".accordion-item")?.classList.contains("active")) {
                    el.style.height = el.scrollHeight + "px";
                }
            },
            { once: true }
        );
    });

    const onEnd = (e) => {
        if (e.propertyName !== "height") return;
        el.removeEventListener("transitionend", onEnd);

        // Optional: nach dem Öffnen Höhe auf "auto" setzen,
        // damit spätere Layout-Änderungen nicht abgeschnitten werden.
        if (el.closest(".accordion-item")?.classList.contains("active")) {
            el.style.transition = "none";
            el.style.height = "auto";
            // overflow kannst du hidden lassen oder entfernen:
            // el.style.overflow = "";
        }
    };

    el.addEventListener("transitionend", onEnd);
}

function collapseSmooth(el) {
    // Wenn vorher auf auto: aktuelle Pixelhöhe fixieren
    el.style.transition = "none";
    el.style.overflow = "hidden";

    const current = el.getBoundingClientRect().height;
    el.style.height = current + "px";

    // Reflow
    el.offsetHeight;

    requestAnimationFrame(() => {
        el.style.transition = "height 300ms ease";
        el.style.height = "0px";
    });

    const onEnd = (e) => {
        if (e.propertyName !== "height") return;
        el.removeEventListener("transitionend", onEnd);
        // optional cleanup
        // el.style.overflow = "";
    };

    el.addEventListener("transitionend", onEnd);
}

function splideSliders() {
    initHeaderSlider();
    initGallerySlider();
    initUSPSlider();
    initServiceList();
    initTeamList();
}

function initUSPSlider() {
    const BREAKPOINT = 992; // < 992px = Slider aktiv
    const SELECTOR = '.js-usp-splide';

    document.querySelectorAll(SELECTOR).forEach((container) => {
        // Originalzustand merken (damit Desktop 1:1 wiederhergestellt werden kann)
        const originalHTML = container.innerHTML;

        let splideInstance = null;
        let isBuiltAsSplide = false;

        function buildSplideDom() {
            if (isBuiltAsSplide) return;

            const items = Array.from(container.querySelectorAll('.usp-item'));

            // Root als Splide markieren
            container.classList.add('splide');

            // Track + List
            const track = document.createElement('div');
            track.className = 'splide__track';

            const list = document.createElement('div');
            list.className = 'splide__list';

            // Items zu Slides
            items.forEach((item) => {
                item.classList.add('splide__slide');
                list.appendChild(item);
            });

            track.appendChild(list);

            // Neu zusammensetzen
            container.innerHTML = '';
            container.appendChild(track);

            isBuiltAsSplide = true;
        }

        function restoreOriginalDom() {
            if (!isBuiltAsSplide) return;

            if (splideInstance) {
                splideInstance.destroy(true);
                splideInstance = null;
            }

            container.innerHTML = originalHTML;
            container.classList.remove('splide');
            container.classList.add('usp-list');

            isBuiltAsSplide = false;
        }

        function enableSplide() {
            if (splideInstance) return;

            // Splide muss global verfügbar sein (CDN) oder vorher importiert werden
            splideInstance = new Splide(container, {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                gap: '1rem',
                pagination: true,
                arrows: false,
                autoplay: true,
                interval: 5000,
                speed: 1200,
            });

            splideInstance.mount();
        }

        function update() {
            const isMobile = window.matchMedia(`(max-width: ${BREAKPOINT - 1}px)`).matches;

            if (isMobile) {
                buildSplideDom();
                enableSplide();
            } else {
                restoreOriginalDom();
            }
        }

        // Initial
        update();

        // Resize debounce
        let resizeTimer = null;
        window.addEventListener('resize', () => {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(update, 150);
        });
    });
}


function initHeaderSlider() {
    if (document.querySelector('.splide[data-slider="header"]')) {
        document.querySelectorAll('.splide[data-slider="header"]').forEach(function (el) {
            new Splide(el, {
                type: 'loop',
                autoplay: true,
                interval: 5000,
                speed: 1200,
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                drag: true,
                rewind: true,
            }).mount();
        });
    }
}

function initServiceList() {
    const BREAKPOINT = 992; // < 992px = Slider aktiv
    const SELECTOR = '.js-service-splide';

    document.querySelectorAll(SELECTOR).forEach((container) => {
        // Falls initServiceList() mehrfach aufgerufen wird: doppelte Initialisierung verhindern
        if (container.dataset.serviceListInit === '1') return;
        container.dataset.serviceListInit = '1';

        const originalHTML = container.innerHTML;
        const originalClassName = container.className; // enthält auch "service-list {field.layout} ..."

        let splideInstance = null;
        let isBuiltAsSplide = false;

        function buildSplideDom() {
            if (isBuiltAsSplide) return;

            const items = Array.from(container.querySelectorAll('.service-item'));

            // Root wird Splide
            container.classList.add('splide');
            container.classList.remove('service-list');
            container.classList.add('service-list-mobile');

            // Track + List
            const track = document.createElement('div');
            track.className = 'splide__track';

            const list = document.createElement('div');
            list.className = 'splide__list';

            // Items zu Slides machen
            items.forEach((item) => {
                item.classList.add('splide__slide');
                list.appendChild(item);
            });

            track.appendChild(list);

            // Neu zusammensetzen
            container.innerHTML = '';
            container.appendChild(track);

            isBuiltAsSplide = true;
        }

        function enableSplide() {
            if (splideInstance) return;

            splideInstance = new Splide(container, {
                type: 'slide',
                perPage: 1.35,
                perMove: 1,
                arrows: false,
                pagination: true,
                drag: true,
                gap: '1rem',
                speed: 800,
                rewind: false,
                autoplay: false,
                focus: 'center',
                trimSpace: false,
                preloadPages: 2,
            });

            splideInstance.mount();
        }

        function restoreOriginalDom() {
            if (!isBuiltAsSplide) return;

            if (splideInstance) {
                splideInstance.destroy(true);
                splideInstance = null;
            }

            // Komplett zurück auf Original (HTML + Klassen)
            container.innerHTML = originalHTML;
            container.className = originalClassName;

            isBuiltAsSplide = false;
        }

        function update() {
            const isMobile = window.matchMedia(`(max-width: ${BREAKPOINT - 1}px)`).matches;

            if (isMobile) {
                buildSplideDom();
                enableSplide();
            } else {
                restoreOriginalDom();
            }
        }

        // Initial
        update();

        // Resize debounce
        let resizeTimer = null;
        window.addEventListener('resize', () => {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(update, 150);
        });
    });
}


function initGallerySlider() {
    if (document.querySelector('.splide[data-slider="gallery"]')) {
        document.querySelectorAll('.splide[data-slider="gallery"]').forEach(function (el) {
            new Splide(el, {
                type: 'loop',
                perPage: 3.5,
                perMove: 1,
                autoplay: true,
                focus: 'center',
                interval: 5000,
                speed: 1200,
                arrows: true,
                pagination: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                lazyLoad: true,
                preloadPages: 1,
                keyboard: true,
                drag: true,
                trimSpace: false,
                breakpoints: {
                    992: {
                        perPage: 1.5,
                        gap: '1rem',
                        arrows: false,
                    }
                }
            }).mount();
        });
    }
}

function feedbackLoop() {
    if (typeof gsap === 'undefined') {
        return;
    }
    const track = document.querySelector(".feedback-slider .feedback-track");
    const slider = document.querySelector(".feedback-slider");
    if (!track || !slider) return;

    if (!track.dataset.cloned) {
        const cards = Array.from(track.children);
        cards.forEach((card) => {
            const clone = card.cloneNode(true);
            clone.classList.add("feedback-card--clone");
            track.appendChild(clone);
        });
        track.dataset.cloned = "true";
    }

    const totalWidth = track.scrollWidth / 2; // eine Sequenz

    gsap.to(track, {
        x: -totalWidth,
        duration: 60,
        repeat: -1,
        ease: "linear",
        modifiers: {
            x: (x) => {
                const current = parseFloat(x);
                // sorgt für endlosen Loop
                if (current <= -totalWidth) {
                    return "0px";
                }
                return x;
            },
        },
    });

    // Hover pausieren (optional)
    slider.addEventListener("mouseenter", () => gsap.globalTimeline.pause());
    slider.addEventListener("mouseleave", () => gsap.globalTimeline.resume());
}


function initMobileNav() {
    const navBars = document.querySelectorAll('.nav-bar');
    if (!navBars.length) return;

    let scrollY = 0;

    function lockScroll() {
        // schon gelockt? nichts tun
        if (document.body.classList.contains('is-scroll-locked')) return;

        scrollY = window.scrollY || window.pageYOffset;

        document.documentElement.classList.add('is-scroll-locked');
        document.body.classList.add('is-scroll-locked');

        // Fixiert den Body an aktueller Position -> kein Jump
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
    }

    function unlockScroll() {
        if (!document.body.classList.contains('is-scroll-locked')) return;

        document.documentElement.classList.remove('is-scroll-locked');
        document.body.classList.remove('is-scroll-locked');

        // Styles zurücksetzen
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';

        // Zur gespeicherten Position zurück
        window.scrollTo(0, scrollY);
    }

    navBars.forEach(function (navBar) {
        const nav = navBar.closest('.nav') || navBar;
        const toggle = navBar.querySelector('[data-nav-toggle]');
        const menu = navBar.querySelector('[data-nav-menu]');
        if (!toggle || !menu) return;

        toggle.setAttribute('aria-expanded', 'false');

        function openNav() {
            nav.classList.add('open');
            toggle.setAttribute('aria-expanded', 'true');
            lockScroll();
        }

        function closeNav() {
            nav.classList.remove('open');
            toggle.setAttribute('aria-expanded', 'false');

            // nur entsperren, wenn wirklich keine Mobile-Navi mehr offen ist
            const anyOpenNav = document.querySelector('.nav.open');
            if (!anyOpenNav) unlockScroll();
        }

        function toggleNav() {
            if (nav.classList.contains('open')) closeNav();
            else openNav();
        }

        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            toggleNav();
        });

        document.addEventListener('click', function (e) {
            if (!nav.classList.contains('open')) return;
            if (navBar.contains(e.target)) return;
            closeNav();
        });

        document.addEventListener('keydown', function (e) {
            if (!nav.classList.contains('open')) return;
            if (e.key === 'Escape') closeNav();
        });

        menu.querySelectorAll('a').forEach(function (a) {
            a.addEventListener('click', function () {
                if (nav.classList.contains('open')) closeNav();
            });
        });

        const desktopMq = window.matchMedia('(min-width: 1024px)');

        function handleBreakpoint(e) {
            if (e.matches) {
                closeNav();
            }
        }

        handleBreakpoint(desktopMq);

        if (desktopMq.addEventListener) desktopMq.addEventListener('change', handleBreakpoint);
        else desktopMq.addListener(handleBreakpoint);
    });
}


function initNavDropdowns() {
    const navMenus = document.querySelectorAll('[data-nav-menu]');
    if (!navMenus.length) return;
    if (window.innerWidth >= 993) return;

    navMenus.forEach((menu) => {
        const dropdownItems = menu.querySelectorAll('.has-dropdown');

        dropdownItems.forEach((item) => {
            const toggle = item.querySelector('.dropdown-icon');
            const dropdown = item.querySelector('.nav-dropdown');

            if (!toggle || !dropdown) return;

            // initial closed
            item.classList.remove('is-open');
            dropdown.style.height = '0px';

            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const isOpen = item.classList.contains('is-open');

                // alle anderen schließen
                dropdownItems.forEach((other) => {
                    const otherDropdown = other.querySelector('.nav-dropdown');
                    if (!otherDropdown) return;

                    other.classList.remove('is-open');
                    otherDropdown.style.height = '0px';
                });

                // aktuellen togglen
                if (!isOpen) {
                    item.classList.add('is-open');

                    // WICHTIG: Höhe vom Dropdown selbst (Inhalt)
                    dropdown.style.height = dropdown.scrollHeight + 'px';
                } else {
                    // wenn du "erneut klicken = schließen" willst:
                    item.classList.remove('is-open');
                    dropdown.style.height = '0px';
                }
            });
        });
    });
}



function toggleFooterCol(el) {
    const elementCol = el.closest('.footer-col');
    if (!elementCol) return;

    if (elementCol.classList.contains('logo') || elementCol.classList.contains('company-info')) {
        return;
    }

    const wasOpen = elementCol.classList.contains('open');

    document.querySelectorAll('footer .footer-col.open').forEach((col) => {
        col.classList.remove('open');
    });

    if (!wasOpen) {
        elementCol.classList.add('open');
    }
}



function initPriceListNav() {
    const nav = document.querySelector(".price-list-nav");
    if (!nav) return;

    const priceLists = document.querySelectorAll(".price-list");
    if (priceLists.length === 0) return;

    const navItems = nav.querySelectorAll('a');
    navItems.forEach(listItem => {
        const anchor = listItem.href.split('#')[1];
        listItem.setAttribute('data-anchor', anchor);
    });

    function priceListNavCheckPosition() {
        var triggerY = 0;
        triggerY += document.querySelector('.nav-bar').getBoundingClientRect().height;
        triggerY += document.querySelector('.price-list-nav').getBoundingClientRect().height;

        priceLists.forEach(list => {
            const rect = list.getBoundingClientRect();
            const itemStart = rect.top;
            const itemEnd = rect.bottom;

            if (triggerY >= itemStart && triggerY <= itemEnd) {
                const anchor = list.getAttribute('data-anchor');


                const nav = document.querySelector(".price-list-nav");

                nav.querySelectorAll('a').forEach(element => {
                    element.classList.remove('is-active');
                });

                const activeItem = nav.querySelector('a[data-anchor="' + anchor + '"]');
                activeItem.classList.add('is-active');

                if (window.innerWidth <= 992 && activeItem) {
                    const scroller = activeItem.closest('.price-list-nav .list');
                    if (!scroller) return;

                    const itemRect = activeItem.getBoundingClientRect();
                    const scrollerRect = scroller.getBoundingClientRect();

                    const delta = (itemRect.left - scrollerRect.left) - (scrollerRect.width / 2 - itemRect.width / 2);

                    scroller.scrollTo({
                        left: scroller.scrollLeft + delta,
                        behavior: 'smooth'
                    });
                }


            }
        });
    }

    window.addEventListener("scroll", priceListNavCheckPosition, { passive: true });
    priceListNavCheckPosition();

    function priceListNavLink() {
        const hash = window.location.hash;
        if (!hash) return;

        const anchor = decodeURIComponent(hash.slice(1));
        const priceList = document.querySelector(`.price-list[data-anchor="${CSS.escape(anchor)}"]`);
        if (!priceList) return;

        const navBar = document.querySelector(".nav-bar");
        const priceNav = document.querySelector(".price-list-nav");

        const navBarH = navBar ? navBar.getBoundingClientRect().height : 0;
        const priceNavH = priceNav ? priceNav.getBoundingClientRect().height : 0;

        const targetTop =
            priceList.getBoundingClientRect().top + window.scrollY - navBarH - priceNavH + 1;

        window.scrollTo({
            top: Math.max(0, targetTop),
            behavior: "smooth"
        });

        history.replaceState(
            null,
            document.title,
            window.location.pathname + window.location.search
        );
    }

    window.addEventListener("hashchange", priceListNavLink);
    // auch beim ersten Laden mit Hash:
    priceListNavLink();

}





function loadMaps() {
    const STORAGE_KEY = 'google_maps_consent';

    // Zustimmung merken (damit beim nächsten Seitenaufruf direkt geladen werden kann)
    localStorage.setItem(STORAGE_KEY, 'true');

    // Alle Map-Wrapper laden (falls du mehrere Maps auf einer Seite hast)
    document.querySelectorAll('.google-maps').forEach((mapWrapper) => {
        const uid = mapWrapper.dataset.mapUid;
        const mapContainer = document.getElementById('gmap-' + uid);
        const consentBox = mapWrapper.querySelector('.gm-consent');

        if (!mapContainer || mapContainer.dataset.loaded === '1') return;

        mapContainer.innerHTML = `
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2601.240630950266!2d9.139116313064775!3d49.30972646871821!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47978aa26af50753%3A0x6844bc462a464542!2sEhrenmalstra%C3%9Fe%2068%2C%2074855%20Ha%C3%9Fmersheim!5e0!3m2!1sde!2sde!4v1767973431355!5m2!1sde!2sde"
        width="100%"
        height="100%"
        style="border:0;"
        allowfullscreen
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>
    `;

        mapContainer.dataset.loaded = '1';
        if (consentBox) consentBox.style.display = 'none';
    });
}



function initTeamList() {
    const BREAKPOINT = 992; // < 992px = Slider
    const SELECTOR = '.js-team-splide';

    document.querySelectorAll(SELECTOR).forEach((container) => {
        // Schutz vor mehrfacher Initialisierung
        if (container.dataset.teamInit === '1') return;
        container.dataset.teamInit = '1';

        const originalHTML = container.innerHTML;
        const originalClassName = container.className;

        let splideInstance = null;
        let isSplide = false;

        function buildSplideDom() {
            if (isSplide) return;

            const items = Array.from(container.querySelectorAll('.team-item'));

            container.classList.add('splide');

            const track = document.createElement('div');
            track.className = 'splide__track';

            const list = document.createElement('div');
            list.className = 'splide__list';

            items.forEach((item) => {
                item.classList.add('splide__slide');
                list.appendChild(item);
            });

            track.appendChild(list);
            container.innerHTML = '';
            container.appendChild(track);

            isSplide = true;
        }

        function enableSplide() {
            if (splideInstance) return;

            splideInstance = new Splide(container, {
                type: 'slide',
                perPage: 1,
                gap: '1rem',
                arrows: false,
                pagination: true,
                drag: true,
            });

            splideInstance.mount();
        }

        function destroySplide() {
            if (!isSplide) return;

            if (splideInstance) {
                splideInstance.destroy(true);
                splideInstance = null;
            }

            container.innerHTML = originalHTML;
            container.className = originalClassName;

            isSplide = false;
        }

        function update() {
            const isMobile = window.matchMedia(`(max-width: ${BREAKPOINT - 1}px)`).matches;

            if (isMobile) {
                buildSplideDom();
                enableSplide();
            } else {
                destroySplide();
            }
        }

        // initial
        update();

        // resize (debounced)
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(update, 150);
        });
    });
}

// Init
document.addEventListener('DOMContentLoaded', () => {
    initTeamList();
});



